import React from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

export const makeStringReadable = (word) => {
  /* Simple Method to remove "_" from strings and convert to Camel Case */
  let i;
  const frags = word.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
};

export function TagsCell(props) {
  /* Helper Element to display tags in a Table as Chips */
  // the props come from the DataTable when the cell is rendered
  const { value } = props;
  return (
    <Stack direction="row" spacing={1}>
      {
        // check if value is dictionary
        value.constructor === Object ? (
          <>
            {
              // if so, render each value
              Object.values(value).map((tag) => (
                <Chip label={tag} key={tag.id} color="primary" />
              ))
            }
          </>
        ) : (
          // otherwise render just the value as Chip
          <Chip label={value} color="primary" />
        )
      }
    </Stack>
  );
}

export const getSelectorStyles = (name, selectedNames, theme) => ({
  fontWeight:
    selectedNames.indexOf(name) === -1
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
});
